<template>
  <div class="map-wrapper">
    <!-- 가로 100%, 세로는 html의 mapHeight와 똑같이 맞춰주세요 -->
    <iframe
      src="/kakaomap.html"
      class="kakao-iframe"
      frameborder="0"
      scrolling="no"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'KakaoMap'
}
</script>

<style scoped>
.map-wrapper {
  width: 100%;      /* 부모 컨테이너 가로 100% */
  max-width: 100%;  /* 화면 밖으로 빠져나가는 것 방지 */
  overflow: hidden;
}

.kakao-iframe {
  width: 100%;      /* 아이프레임 가로 100% */
  height: 400px;    /* kakaomap.html의 mapHeight와 동일하게 설정 */
  border: none;
}
</style>
